const PhoneIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    data-testid="phone-icon"
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.17273 9.99946C2.17273 14.3158 5.68387 17.8272 10 17.8272C14.3161 17.8272 17.8273 14.3158 17.8273 9.99946C17.8273 5.68418 14.3161 2.17285 10 2.17285C5.68387 2.17285 2.17273 5.68418 2.17273 9.99946ZM0 9.99946C0 4.48585 4.48561 0 10 0C15.5144 0 20 4.48585 20 9.99946C20 15.5142 15.5144 20 10 20C4.48561 20 0 15.5142 0 9.99946ZM7.6975 5.24973C7.54699 5.01247 7.26098 4.93876 6.93347 5.05235C6.69696 5.13514 5.88594 5.45671 5.39992 6.11955C3.79887 8.2984 7.51949 12.4466 7.55749 12.4875C8.73003 13.7389 10.9036 15 12.5992 15C13.0632 15 13.4917 14.9056 13.8537 14.691C14.3817 14.3776 14.7027 13.6391 14.8947 13.1973L14.8947 13.1973L14.9327 13.1109V13.1104C15.0747 12.7873 14.9877 12.4698 14.7112 12.3027C14.6913 12.2907 14.6001 12.2379 14.4694 12.1623C14.4129 12.1296 14.3489 12.0926 14.2802 12.0528L13.9043 11.836L13.7385 11.7402C13.4066 11.5482 13.0872 11.3624 13.0427 11.3324C12.7272 11.1128 12.2721 11.0381 11.9641 11.3642C11.9151 11.4157 11.8366 11.5121 11.7441 11.6262L11.738 11.6338C11.5851 11.8228 11.3966 12.0558 11.2426 12.2022C11.1136 12.3254 10.5291 12.1952 9.23705 10.8321C7.8205 9.33885 7.8015 8.91227 7.9165 8.79111C8.08551 8.6129 8.31152 8.39886 8.47552 8.24387C8.57652 8.14846 8.65553 8.07324 8.68703 8.03992C8.88253 7.83345 8.96154 7.3892 8.72003 6.97423C8.53552 6.65619 7.8215 5.44561 7.6975 5.24973Z"
      fill="#41A017"
    />
  </svg>
);

export default PhoneIcon;
